import cn from 'classnames';
import {useEffect, useState} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Accordion from '../../../components/mazraeKit/accordion';
import CustomMultiCheckbox from '../../../components/mazraeKit/customMultiCheckbox';
import CategoryCards from '../../../module/newShop/home/inputGroups';
import {IFiltersData, filtersData, multiSelectData} from './utils';
import {
  ShopListingFilters,
  useShopListingFilters,
} from '../../../hooks/filters/useShopListingFilter';

interface IFiltersKeyValuePairs {
  guid: string;
  title: string;
  code: number;
}
export interface IFilters {
  categories: Array<IFiltersKeyValuePairs>;
  sorting: string;
  has_discount: boolean;
  in_person_possibility: boolean;
  has_delivery: boolean;
  has_guarantee: boolean;
}
const ShopListingBottomSheet = ({
  openBottomSheet,
  setOpenBottomSheet,
}: {
  openBottomSheet: boolean;
  setOpenBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [openAccordion, setOpenAccordion] = useState<boolean>(false);
  const {resetShopListing, setShopListingFilters, shopListingFilter} =
    useShopListingFilters();

  const [filters, setFilters] = useState<IFilters>({
    categories: shopListingFilter?.input_guid,
    sorting: shopListingFilter?.order_by,
    has_discount: shopListingFilter.has_discount as boolean,
    in_person_possibility: shopListingFilter?.in_person_possibility,
    has_delivery: shopListingFilter?.has_delivery,
    has_guarantee: shopListingFilter?.has_guarantee,
  });

  const sortingHandler = (sortingItem: IFiltersData) => {
    setFilters(prev => {
      return {...prev, sorting: sortingItem.value};
    });
  };

  const checkBoxHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilters(prev => {
      return {...prev, [event.target.name]: event.target.checked};
    });
  };
  useEffect(() => {
    // handle removed item by opening modal
    setFilters({
      categories: shopListingFilter?.input_guid,
      sorting: shopListingFilter?.order_by,
      has_discount: shopListingFilter.has_discount as boolean,
      in_person_possibility: shopListingFilter?.in_person_possibility,
      has_delivery: shopListingFilter?.has_delivery,
      has_guarantee: shopListingFilter?.has_guarantee,
    });
  }, [openBottomSheet]);

  return (
    <>
      <BottomSheet
        onDismiss={() => {
          setOpenBottomSheet(false);
        }}
        open={openBottomSheet}
        blocking={true}
        snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.8]}
        className="transition ease-in-out delay-250"
      >
        <div className="pt-2 pb-3">
          <div className="flex justify-between px-3 border-b">
            <p className="font-Medium">فیلتر</p>
            <i
              className="text-xl icon-nameClose-remove"
              onClick={() => setOpenBottomSheet(false)}
            />
          </div>
          <div className="px-3 mt-3 mb-4">
            <span className="text-sm">دسته بندی</span>
          </div>

          <CategoryCards filters={filters} setFilters={setFilters} />
          <div className="flex items-center px-3 border-b">
            <Accordion
              accordionTitle="مرتب‌سازی بر اساس"
              setOpenAccordion={setOpenAccordion}
              openAccordion={openAccordion}
            >
              <div className="flex gap-2 justify-start pb-3">
                {filtersData
                  .filter(f => f.id !== '3') // remove the nearest filter
                  .map(item => (
                    <div
                      key={item.id}
                      className={cn(
                        'border-[1px] text-sm text-farm-shop-500 rounded-full border-farm-shop-500 w-fit py-2 px-2',
                        {
                          'bg-farm-shop-100': item.value === filters.sorting,
                        },
                      )}
                      onClick={() => sortingHandler(item)}
                    >
                      {item.title}
                    </div>
                  ))}
              </div>
            </Accordion>
          </div>
          <div className="flex flex-col gap-3 px-3 mt-4">
            {multiSelectData.map(
              (item: {id: string; title: string; value: string}) => (
                <CustomMultiCheckbox
                  title={item.title}
                  id={item.id}
                  value={item.value}
                  name={item.value}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    checkBoxHandler(e)
                  }
                  defaultChecked={
                    shopListingFilter[item.value as keyof ShopListingFilters]
                      ? true
                      : false
                  }
                  checked={
                    filters[item.value as keyof typeof filters] as boolean
                  }
                />
              ),
            )}
          </div>
          <div className="flex flex-1 gap-2 px-3 mt-6">
            <button
              className="flex justify-center items-center w-3/5 rounded text-white py-2.5 bg-farm-shop-500"
              onClick={() => {
                setShopListingFilters({
                  input_guid: filters.categories,
                  order_by: filters.sorting,
                  in_person_possibility: filters.in_person_possibility,
                  has_delivery: filters.has_delivery,
                  has_guarantee: filters.has_guarantee,
                  has_discount: filters.has_discount,
                });
                setOpenBottomSheet(false);
              }}
            >
              اعمال فیلترها
            </button>
            <button
              className="flex justify-center items-center w-2/5 rounded py-2.5 border-[1px] text-red-500 !border-red-500"
              onClick={() => {
                resetShopListing();
                setOpenBottomSheet(false);
              }}
            >
              حذف فیلترها
            </button>
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

export default ShopListingBottomSheet;
